import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia } from '@mui/material';

const projects = [
  {
    title: 'Portfolio in Figma',
    description: 'A visually appealing and user-friendly portfolio design created in Figma.',
    image: '/Figma.png', // Replace with a Figma-related image
  },
  {
    title: 'Portfolio in React',
    description: 'A dynamic portfolio website built with React showcasing projects and skills.',
    image: 'React.png', // Replace with a React-related image
  },
  {
    title: 'Dashboard Development in Power BI',
    description: 'Data-driven dashboard created using Power BI for real-time insights and analytics.',
    image: 'power.png', // Replace with a Power BI-related image
  },
];

const Projects = () => {
  return (
    <Container sx={{ mt: 4 }}>
      {/* Centering and Bold "Projects" Title */}
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          textAlign: 'center', // Center the title
          fontWeight: 'bold',  // Make the title bold
        }}
      >
        My Projects
      </Typography>

      {/* Grid for Projects */}
      <Grid container spacing={4} justifyContent="center">
        {projects.map((project, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ height: '100%' }}> {/* Ensure all cards have equal height */}
              <CardMedia
                component="img"
                height="140"
                image={project.image}
                alt={project.title}
              />
              <CardContent sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'space-between', 
                height: '100%',
                paddingBottom: '16px', // Add padding to bottom
              }}>
                <Typography variant="h6">{project.title}</Typography>
                <Typography variant="body2" color="textSecondary" sx={{ flexGrow: 1 }}>
                  {project.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Projects;
